export const VACATION_HOME_ABROAD = {
  isHidden: true,
  nickname: 'PRODUCTS.VACATION_HOME_ABROAD.nickname',
  icon:'vacation-home-abroad'
};
